import React, { useState } from 'react';
import { FaCalendarAlt, FaCogs } from 'react-icons/fa';
import api from '../services/api';

const ProcessData = () => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        setLoading(true);

        try {
            const response = await api.post('/process/process-data', {
                start_date: startDate,
                end_date: endDate,
            });

            const successMessage = typeof response.data === 'object' ? response.data.message : response.data;
            setMessage(successMessage);
        } catch (err) {
            if (err.response) {
                const status = err.response.status;
                const detail = err.response.data.detail;

                if (status === 400) {
                    setError(`Bad Request: ${typeof detail === 'object' ? detail.message : detail}`);
                } else if (status === 422) {
                    setError(`Validation Error: ${typeof detail === 'object' ? detail.message : detail}`);
                } else {
                    setError(`Error ${status}: ${typeof detail === 'object' ? detail.message : detail || 'An error occurred'}`);
                }
            } else {
                setError('Wystąpił nieoczekiwany błąd.');
            }
            console.error('Błąd podczas przetwarzania danych:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex flex-col items-center p-4 sm:p-6">
            <div className="bg-white p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-md">
                <h2 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6">
                    Przetwarzanie danych
                </h2>
                
                {message && (
                    <div className="bg-green-50 text-green-700 p-3 rounded-lg mb-4">
                        {message}
                    </div>
                )}
                
                {error && (
                    <div className="bg-red-50 text-red-600 p-3 rounded-lg mb-4">
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-gray-700 mb-2">
                            Data początkowa:
                        </label>
                        <input
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-lg"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-gray-700 mb-2">
                            Data końcowa:
                        </label>
                        <input
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-lg"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        className="w-full bg-softTeal text-pureWhite font-semibold px-4 py-3 rounded-lg hover:bg-warmOrange transition flex items-center justify-center"
                        disabled={loading}
                    >
                        <FaCogs className="mr-2" />
                        {loading ? 'Przetwarzanie...' : 'Przetwórz dane'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ProcessData;
